module.exports = __webpack_public_path__ + "static/media/homepage_popup_20230619.e09c8304.jpg";